import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextButton from '@spothero/ui/text-button';
import IconCheck from '@spothero/icons/check';
import IconInfo from '@spothero/icons/info';
import AlertModal from 'common/alert/AlertModal';

const CancellationInfo = ({
    className,
    cancellationAllowed,
    showFreeCancellation,
}) => {
    const classes = classNames('CancellationInfo', className);
    const [showModal, setShowModal] = useState(false);
    const toggleAlertModal = useCallback(() => setShowModal(!showModal), [
        showModal,
    ]);

    if (cancellationAllowed !== 'no' && !showFreeCancellation) {
        return null;
    }

    return (
        <div className={classes}>
            {cancellationAllowed !== 'no' ? (
                <small className="CancellationInfo-free-cancellation">
                    <IconCheck /> Free cancellation up to start time
                </small>
            ) : (
                <>
                    <small className="CancellationInfo-no-cancellation">
                        This reservation is non-refundable
                        <TextButton
                            className="CancellationInfo-label-button"
                            onClick={toggleAlertModal}
                            iconPosition="right"
                        >
                            <IconInfo />
                        </TextButton>
                    </small>
                    {showModal && (
                        <AlertModal
                            className="CancellationInfo-modal"
                            title="Cancellation"
                            message="Due to rules set by the operator, this reservation is not cancellable. If you choose to cancel this reservation, you will not be refunded any of your payment. You may, however, adjust this reservation to a different time up until 24 hours of the start time of the reservation."
                            onHidden={toggleAlertModal}
                        />
                    )}
                </>
            )}
        </div>
    );
};

CancellationInfo.propTypes = {
    className: PropTypes.string,
    cancellationAllowed: PropTypes.string.isRequired,
    showFreeCancellation: PropTypes.bool,
};

CancellationInfo.defaultProps = {
    showFreeCancellation: false,
};

export default CancellationInfo;
